module.exports = __webpack_public_path__ + "static/media/buttonpaydouble.e99ffc04.png";